import { gql } from "@apollo/client";

import { DashboardGoalFragment } from "@apps/dashboard-new/graphql/dashboard-goal-fragment";

export default gql`
  ${DashboardGoalFragment}
  query getMeetingGoalsNewPageQuery(
    $fetchData: Boolean!
    $goalInvolvingUsers: [Int]!
    $asUsers: [Int]
    $meetingGroupId: Int
    $goalState: GoalState!
    $goalScopes: [GoalScope]
    $goalsCompletedInTheLastXDays: Int
    $after: String
    $first: Int!
  ) {
    artifacts(
      artifactType: goal
      first: $first
      orderBy: "-updated"
      asUsers: $asUsers
      goalState: $goalState
      goalScopes: $goalScopes
      meetingGroupId: $meetingGroupId
      goalInvolvingUsers: $goalInvolvingUsers
      goalsCompletedInTheLastXDays: $goalsCompletedInTheLastXDays
      after: $after
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges @include(if: $fetchData) {
        node {
          activities(first: 1, activityType: goal_checkin) {
            edges {
              node {
                created
              }
            }
          }
          ...DashboardGoalFragment
        }
      }
    }
  }
`;
